import React, { Component } from "react";
import { Trans } from "react-i18next";
import { Flyout } from "@els/els-react--flyout";
import { Col, Row } from "react-bootstrap";
import Utility from "../utility/Utility";
import "../../src/styles/beneficiary-banner.scss";

const BeneficiaryBanner = props => {
  const firstName = props.beneficiaryData?.name[0]?.given[0];
  const middleName = props.beneficiaryData?.name[0]?.given[1]
  const lastName = props.beneficiaryData?.name[0]?.family;
  const patientName = firstName + ((middleName) ? " " + middleName : "") + " " + lastName;
  //const patientName = `${props.beneficiaryData?.name[0]?.given[0]} ${props.beneficiaryData?.name[0]?.family}`;
  const identifierName = props.beneficiaryData?.identifier
    ? props.beneficiaryData?.identifier[0]?.assigner?.display
    : "ID";
  const identifierValue = props.beneficiaryData?.identifier
    ? props.beneficiaryData?.identifier[0]?.value
    : "unavailable";
  return (
    <Row className="beneficiary-banner">
      <div className="beneficiary-details-container">
        <img
          className="inline-block-middle patient-image"
          src={`../../beneficiary-${
            props.beneficiaryData?.gender || "male"
          }.svg`}
          alt="beneficiary"
        />
        <div className="patient-info-container">
          <Row>
            <div className="beneficiary-row beneficiary-name-container">
              <div className="beneficiary-info-question">
                <Trans i18nKey={"patient"}></Trans>:
              </div>
              <div className="beneficiary-name text-capitalize">
                <Flyout
                  flyout={patientName}
                  shouldCloseOnESC={true}
                  id="sampleId"
                  className="beneficiary-name-tooltip"
                  theme="simple"
                  pointerType="default"
                  placement="bottom-start"
                >
                  {patientName}
                </Flyout>
              </div>
            </div>
            <Col md="2" className="beneficiary-row patient-gender-container">
              <div className="beneficiary-info beneficiary-info-question">
                <Trans i18nKey={"gender"}></Trans>:
              </div>
              <span className="beneficiary-info-answer text-capitalize">
                <span>
                  {<Trans i18nKey={props.beneficiaryData?.gender}></Trans>}
                </span>
              </span>
            </Col>
            <Col
              lg="3"
              md="4"
              className="beneficiary-row patient-gender-container"
            >
              <div className="beneficiary-info beneficiary-info-question">
                <Trans i18nKey={"age"}></Trans>:
              </div>
              <span className="beneficiary-info-answer text-capitalize">
                <span>
                  {
                    <Trans
                      i18nKey={Utility.getAge(props.beneficiaryData?.birthDate)}
                    ></Trans>
                  }
                </span>
              </span>
            </Col>
            <Col
              md="2"
              className="beneficiary-row patient-identifier-container"
            >
              <div className="beneficiary-info-question">
                <Trans i18nKey={identifierName}></Trans>:
              </div>
              <span className="beneficiary-info-answer">
                {identifierName == "ID" ? (
                  <Trans i18nKey={identifierValue}></Trans>
                ) : (
                  identifierValue?.toUpperCase()
                )}
              </span>
            </Col>
          </Row>
        </div>
      </div>
    </Row>
  );
};

export default BeneficiaryBanner;
